import ProjectListDoc from "../../../components/project/ProjectListDoc";

const ProjectListDocPage = () => {
  return <ProjectListDoc />;
};

export default ProjectListDocPage;
